<script lang="ts">
	import { AdvancedCard, LabelList, DaySchedule, IconButton } from '@Shelly/shelly-design-system';
	import { startsWeekOnSun } from 'src/helpers/date_helper';
	import { isSubAccount } from 'src/helpers/user_helpers';
	import { format } from 'svelte-i18n';

	export let title: string = 'UNDEFINED VAL',
		avatar: any = { icon: 'far fa-termometer' },
		subtitle: {} = { value: 'Condition Description', bold: false },
		description: {} = { value: 'Additional info', icon: 'fas fa-clock' },
		labelList = [],
		withLabelList = false,
		withSchedule = false,
		withEdit = true,
		days = [];

	const isFocusable = false;

	if (startsWeekOnSun()) {
		days.unshift(days.pop());
	}
</script>

{#if withLabelList}
	<AdvancedCard aria-label={title} isCondensed {avatar} {title} {isFocusable}>
		<LabelList {labelList} slot="main" size="s" />
		<svelte:fragment slot="right">
			{#if !isSubAccount() && withEdit}
				<IconButton
					aria-label={$format('input_edit', { default: 'Edit' })}
					on:click
					icon="fa-solid fa-pen"
					class="align-self-center"
				/>
			{/if}
		</svelte:fragment>
	</AdvancedCard>
{:else if withSchedule}
	<AdvancedCard aria-label={title} isCondensed {title} {avatar} {subtitle} {description} {isFocusable}>
		<DaySchedule {days} slot="title" />
		<svelte:fragment slot="right">
			{#if !isSubAccount() && withEdit}
				<IconButton
					aria-label={$format('input_edit', { default: 'Edit' })}
					on:click
					icon="fa-solid fa-pen"
					class="align-self-center"
				/>
			{/if}
		</svelte:fragment>
	</AdvancedCard>
{:else}
	<AdvancedCard aria-label={title} isCondensed {avatar} {title} {subtitle} {description} {isFocusable}>
		<svelte:fragment slot="right">
			{#if !isSubAccount() && withEdit}
				<IconButton
					aria-label={$format('input_edit', { default: 'Edit' })}
					on:click
					icon="fa-solid fa-pen"
					class="align-self-center"
				/>
			{/if}
		</svelte:fragment>
	</AdvancedCard>
{/if}
